import { ListStore, ListStoreProps } from '@/main/store/@types/list.d';

import { types } from '../types';
import { Filter, ZakazkaDropdownList } from './state';


type State = ListStore<Filter, ZakazkaDropdownList, {}, null, ListStoreProps>;

type Data<T = {}> = { data: { value: number, text: string } & T };

export const mutations = {
	setZakazkaCheckboxFilters(state: State, value: boolean) {
		state.filter.NabidkaPrp = value;
		state.filter.UvolnenePrp = value;
		state.filter.UzavrenePrp = value;
	},
	[types.mutations.ZAKAZKA_FILTER_ZAKAZNIK_SELECT_MAPPER](state: State, { data }: Data) {
		state.filter.ZakaznikId = data.value;
		state.filter.ZakaznikIdText = data.text;
	},
	// TODO: what is the type of OzakazkaIdNr?
	[types.mutations.ZAKAZKA_FILTER_OZAKAZKA_SELECT_MAPPER](state: State, { data }: Data<{ nr: null }>) {
		state.filter.OzakazkaId = data.value;
		state.filter.OzakazkaIdText = data.text;
		state.filter.OzakazkaIdNr = data.nr;
	},
	[types.mutations.ZAKAZKA_FILTER_POJISTOVNA_SELECT_MAPPER](state: State, { data }: Data) {
		state.filter.PojistovnaId = data.value;
		state.filter.PojistovnaIdText = data.text;
		state.filter.PojistovnaIdPrp = !data.value ? null : true; // TODO: PojistovnaIdPrp should be computed?
	},
	[types.mutations.ZAKAZKA_FILTER_LEAZING_ZAKAZNIK_SELECT_MAPPER](state: State, { data }: Data) {
		state.filter.LeaszakaznikId = data.value;
		state.filter.LeaszakaznikIdText = data.text;
		state.filter.LeaszakaznikIdPrp = !data.value ? null : true;
	},
	[types.mutations.ZAKAZKA_FILTER_SMLUNI_PARTNER_SELECT_MAPPER](state: State, { data }: Data) {
		state.filter.SmluvpartnerId = data.value;
		state.filter.SmluvpartnerIdText = data.text;
	},
	[types.mutations.ZAKAZKA_FILTER_ZADAVATEL_SELECT_MAPPER](state: State, { data }: Data<{ jmeno: null, osobniCis: null }>) {
		state.filter.VstupPracId = data.value;
		state.filter.VstupPracIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
		state.filter.VstupPracOsobniCis = data.osobniCis;
	},
};
